import { createSelector } from '@reduxjs/toolkit';
import { ApplicationState } from '../../../redux/store';
import { TrainingsListState } from '../types';

const selectTrainingsListState = (state: ApplicationState): TrainingsListState => state.trainingsList;

export const selectTrainingsList = createSelector(selectTrainingsListState, state => state?.response?.content || []);
export const selectTrainingsListLoading = createSelector(selectTrainingsListState, state => state.loading);